import { alertConstants } from '../_constants';

export function alertReducer(state = {}, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        className: 'green',
        message: action.message,
      };
    case alertConstants.ERROR:
      return {
        className: 'red',
        message: action.message,
      };
    case alertConstants.CLEAR:
      return {};
    default:
      return state;
  }
}
